import React from 'react';
import { Col, Row, Nav } from 'react-bootstrap';
import BugReports from './AdminPortal.BugReports';
import PlayedGames from './AdminPortal.PlayedGames';
import RoomCleanup from './AdminPortal.RoomCleanup';
import PlayerBots from './AdminPortal.PlayerBots';

export default class AdminPortal extends React.Component
{
  state = {
    activeTab: 'bugReports'
  };

  handleTabSelect = ( tabKey ) =>
  {
    console.log( "AdminPortal: Tab selected:", tabKey );
    this.setState( { activeTab: tabKey } );
  }

  render()
  {
    const { activeTab } = this.state;

    return (

      <>
        <Row>
          <Col>
            <div className="panel admin-portal-container" style={ { margin: "20px" } }>
              <div className="admin-portal-content">
                <h2>Admin Portal</h2>

                <Nav variant="tabs" activeKey={ activeTab } onSelect={ this.handleTabSelect } className="mb-3 admin-portal-tabs">
                  <Nav.Item>
                    <Nav.Link eventKey="bugReports">Bug Reports</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="playedGames">Played Games</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="roomCleanup">Room Cleanup</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="playerBots">PlayerBots</Nav.Link>
                  </Nav.Item>
                </Nav>

                <div className="admin-portal-tab-content" style={ { display: 'flex', flexDirection: 'column', height: '100%' } }>
                  { activeTab === 'bugReports' && <BugReports /> }
                  { activeTab === 'playedGames' && <PlayedGames /> }
                  { activeTab === 'roomCleanup' && <RoomCleanup /> }
                  { activeTab === 'playerBots' && <PlayerBots /> }
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </>

    );
  }
}


